export interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryClick: (category: string) => void;
}

export function CategoryFilter({ categories, activeCategory, onCategoryClick }: CategoryFilterProps) {
  if (categories.length <= 2) return null;

  return (
    <nav className="bg-[#337ab8] md:mx-4" aria-label="Recently viewed categories">
      <h4 className="m-0 px-3 pb-0.5 pt-2.5 text-sm font-semibold text-white">Categories</h4>
      <div className="overflow-x-auto whitespace-nowrap px-3 py-2">
        <ul className="m-0 flex list-none gap-1.5 p-0 md:flex-wrap">
          {categories.map((category) => {
            const optionValue = category === 'All' ? '' : category;
            const isActive = activeCategory === category.toLowerCase();
            return (
              <li key={category} className="inline-block shrink-0 last:pr-2">
                <button
                  type="button"
                  data-option={optionValue}
                  onClick={() => onCategoryClick(category === 'All' ? 'all' : category.toLowerCase())}
                  className={[
                    'min-w-14 rounded px-4 py-1.5 text-center text-[11px] uppercase',
                    isActive ? 'bg-[#f7c2cb] text-[#242424]' : 'bg-white text-[#242424]',
                  ].join(' ')}
                >
                  {category}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
